import auth from './auth';
import challengeBanner from './challenge-banner';
import customWorkouts from './custom-workouts';
import deployUpdate from './deploy-update';
import editWorkout from './edit-workout';
import exercises from './exercises';
import experiments from './experiments';
import fileSync from './file-sync';
import health from './health';
import localSettings from './local-settings';
import musicPlayer from './music-player';
import notifications from './notifications';
import photo from './photo';
import plans from './plans';
import portal from './portal';
import purchase from './purchase';
import subscription from './subscription';
import ui from './ui';
import user from './user';
import workoutPlayer from './workout-player';
import workouts from './workouts';
import userAssignments from './user-assignments';

import { combineReducers } from 'redux';

const rootReducer = combineReducers({
  auth,
  challengeBanner,
  customWorkouts,
  deployUpdate,
  editWorkout,
  exercises,
  experiments,
  fileSync,
  health,
  localSettings,
  musicPlayer,
  notifications,
  photo,
  plans,
  portal,
  purchase,
  subscription,
  ui,
  user,
  workoutPlayer,
  workouts,
  userAssignments,
});

export default rootReducer;
